module.exports = __webpack_public_path__ + "static/media/Developmentbanner@3x.39c40f2e.png";